import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"
import {
  isProjectProductPosition,
  isProjectProductPositionAddon,
  isProjectRoom
} from "shared/types/Project"
import { Room } from "shared/types/Room"
import { ProductPositionAddon } from "shared/types/__generated__/graphql"
import { RowRendererProps } from "shared/ui/table/types"

import { ProductPositionTableProductPositionAddonRow } from "./rows/product-position-addon/ProductPositionTableProductPositionAddonRow"
import { ProductPositionTableSharedProductPositionRowConnector } from "./rows/product-position/ProductPositionTableSharedProductPositionRowConnector"
import { ProductPositionTableRoomRow } from "./rows/room/ProductPositionTableRoomRow"

export const SharedProductPositionTableRow = React.memo(
  (props: RowRendererProps<ProductPosition | ProductPositionAddon | Room>) => {
    const { item } = props
    if (isProjectProductPositionAddon(item)) {
      return (
        <ProductPositionTableProductPositionAddonRow {...props} item={item} />
      )
    }
    if (isProjectProductPosition(item)) {
      return (
        <ProductPositionTableSharedProductPositionRowConnector
          {...props}
          item={item}
        />
      )
    }
    if (isProjectRoom(item)) {
      return <ProductPositionTableRoomRow {...props} item={item} actions={[]} />
    }
    return null
  }
)
